import type { CoverableDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/quote';
import type { DSSPaymentFrequency } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { ListBox } from '@flos/react-ui';
import { useRecoilValue } from 'recoil';
import { externalCasesAtom } from '../../../recoil/atoms/externalCasesAtom';
import { paymentFrequencyMap, periodicityUnit } from '../../../utils/currencyUtil';
import { convertLocalDateDTOToDate, convertLocalDateToString } from '../../../utils/dateUtil';
import { coverableToExternalCase } from '../../../utils/externalCasesUtil';
import Currency from '../../../shared_components/Currency/Currency';

const ProductAndPrice = ({
    coverable,
    paymentFrequency,
    isPaymentYearly
}: {
    coverable: CoverableDTO;
    paymentFrequency: DSSPaymentFrequency;
    isPaymentYearly: boolean;
}): React.JSX.Element => {
    const allExternalCases = useRecoilValue(externalCasesAtom);
    const externalCase = coverableToExternalCase(coverable, allExternalCases);
    return (
        <div className="u-spacing-inset-m--stretch-max">
            <ListBox
                theme={'transparent'}
                title={coverable.flavourName ?? ''}
                subtitle={coverable.name}
                action={
                    <h6 className="u-text-right">
                        <Currency
                            price={
                                paymentFrequency === paymentFrequencyMap.monthly
                                    ? coverable.monthlyPrice?.amount ?? 0
                                    : coverable.yearlyPrice?.amount ?? 0
                            }
                            paymentFrequencyPostfix={periodicityUnit[paymentFrequency]}
                        />
                    </h6>
                }
            />
            {externalCase?.startDate && (
                <p className="paragraph--small u-color-primary-1-base u-spacing-stack-xs">
                    Forsikringen gælder fra{' '}
                    {convertLocalDateToString(convertLocalDateDTOToDate(externalCase.startDate))}
                </p>
            )}
            {externalCase?.cancellationDate && externalCase.otherCompany && (
                <p className="paragraph--small u-color-secondary-4-medium">
                    (samtidig opsiger vi forsikringen i {externalCase.otherCompany.name} fra{' '}
                    {convertLocalDateToString(
                        convertLocalDateDTOToDate(externalCase.cancellationDate)
                    )}
                    )
                </p>
            )}
        </div>
    );
};

export default ProductAndPrice;
